<template>
    <div id="vendors-items-container">
        <div class="row">
            <div class="col-12">
                <h4 class="page-title text-truncate">{{$t('DrugInventoryItem.ItemCategory')}}</h4>
                <div class="row">
                    <div class="col-sm-12 col-md-3">                      
                        <MdButton
                            v-bind:Label="$t('ItemCategory.AddTitle')" 
                            v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-on:click="AdditemCateg"
                            v-bind:Name="'btn_add_vendor'">
                        </MdButton>
                    </div>

                    <div  class="col-sm-12 col-md-9 mb-4">
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group" dir="ltr">
                                <input 
                                    type="text" 
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="parameter.SearchCriteria"   
                                    @keyup.enter="SearchVendors"                            
                                >
                                <div class="input-group-append">
                                    <div class="input-group-append">
                                        <MdButton 
                                            v-bind:Name="'btnsearchinput'"
                                            v-bind:VariantProp="'btn btn-sm search-attached'"
                                            v-bind:IconClass="'mdi mdi-magnify'"
                                            v-on:click="SearchitemCateg">
                                        </MdButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mt-2">
                <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                <div class="row">
                    <div class="col-md-12">
                        <MdTable 
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:isReadOnly="isReadOnly"
                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            v-bind:VisibleEditIcon="true"
                            v-bind:VisibleDeleteIcon="true"
                            :editIconEvent="EdititemCateg"
                            :deleteIconEvent="RemoveitemCateg"
                            :onRowSelected="onRowSelected"
                            :onFiltered="onFiltered"
                            :pageChanged="pageChanged"
                            :perPageFunction="PerPageFunction">
                        </MdTable>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ItemCategoryService from '@/services/itemcategory.service'
import DBFunctions from '@/common/DBFunctions.js'
import ShowMessage from '@/components/messages/ShowMessage.js';
import Permission from '@/common/Permission'

export default {
    name: 'ItemcategoryListing',
    mixins: [DBFunctions, ShowMessage, Permission],

    data() {
        return {
            OptionsRightMenu:{
                 visible:false,
                ItemsList:[],
                btnvisible:false,
                itemdisabled: false,
                Mode:this.edit_mode,
                favButtonAtion:false 
            }, 
            parameter: {
                SearchCriteria: '',
                PageNumber : 0,
                PageSize: 0 ,
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            fields: [
                { key: 'categoryCode', sortable: true, label: this.$t('Shared.Code'), class: 'text-rigth'},       
                { key: 'description', sortable: true, label: this.$t('Shared.Description'), class: 'text-rigth' },      
            ],
            pageOptions: [5, 10, 15 ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            items: [],
            isReadOnly: false,
            ShowMessageIsEmpty:false,
            Mode:'', 
        }
    },

    methods: {
        AdditemCateg() {
            this.Mode = "Add";
            this.emitDataforFavorites();  
            this.$emit('onUpdatedMenu', '');  
            this.$router.push({ name: "itemCategAdd" })
        },

        getitemCategListing() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            ItemCategoryService
                .getItemCategories(this.parameter)
                .then((response) => {
                    if(response.status == '200' && response.data && response.data.length > 0){
                        this.items = response.data;

                        let headerString = response.headers["x-pagination"];
                        const Header = JSON.parse(headerString);
                        this.totalRows = Header.TotalCount;
                    }

                    this.ShowMessageIsEmpty = this.items.length === 0;
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        EdititemCateg(row) {
            this.Mode = "Edit";
            this.$router.push({ name: "itemCategEdit", params: {id: row.categoryCode} });
        },

        RemoveitemCateg(row) {
            this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$tc('Shared.DelRecord'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
                    id:'modal_delete_vendor'
				})
                .then(value => {
                    if(value){
                        ItemCategoryService.delete(row.categoryCode)
                            .then(() => {
                                this.currentPage = 1;
                                this.SearchitemCateg();
                            })
                            .catch((error) => {
                                this.showResponseErrorMessage(error);
                            });
                    }
                })
        },

        pageChanged(page) {            
            this.currentPage = page;
            this.getitemCategListing();
        },

        PerPageFunction(perpage){
            this.perPage = perpage;
            this.currentPage = 1;
            this.getitemCategListing();
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },

        onRowSelected(items) {    
           this.selected = items;
        },

        SearchitemCateg() {
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getitemCategListing();
        },

    },

    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        this.$nextTick(() => {
            this.getitemCategListing();
        });
    }
}
</script>